import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('terms'),
    subtitle: defineMessage('terms_refer_to_the_spec_ransaction_or_agreement'),
    placeholder: defineMessage('enter_terms'),
};
